import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Flow from './views/Flow.vue'

import OrderList from './views/OrderList.vue'
import Order from './views/Order.vue'
import Login from './views/Login.vue'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
    path: '/',
    name: 'home',
    component: Home
  }, {
    path: '/flow',
    name: 'flow',
    component: Flow
  }, {
    path: '/order-list',
    name: 'order-list',
    component: OrderList
  }, {
    path: '/order',
    name: 'order',
    component: Order
  },{
    path: '/login',
    name: 'login',
    component: Login
  },
  ]
})

router.beforeEach((to, from, next) => {
  const { user } = JSON.parse(localStorage.getItem('auth') || 'null') || {}

  // if (to.name != 'deposit' && user && user.allow_order == '0' && user.type == 'agency') {
  //   alert("direct to deposit")
  //   next('/deposit')
  //   return
  // }

  var mobleNav = document.getElementById("nav")
  if (mobleNav) {
    mobleNav.style.display = "none"
    document.body.className = ""
  }
  next()
})
export default router
